<template>
  <LoadingState
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex
      v-if="method"
      xs12
      ma-3
    >
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <translatable
            :language="language"
            v-model="method"
            field-name="name"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('name')"
                :label="$t('Name')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
          <translatable
            :language="language"
            v-model="method"
            field-name="description"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('description')"
                :label="$t('Description')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
        </template>
      </translations-tabs>
      <v-text-field
        v-model="method.merchantId"
        :error-messages="method.displayErrors('merchantId')"
        :label="$t('Merchant ID')"
        outline
      />
      <v-text-field
        v-model="method.tokenizationKey"
        :error-messages="method.displayErrors('tokenizationKey')"
        :label="$t('Tokenization Key')"
        outline
      />
      <v-text-field
        v-model="method.publicKey"
        :error-messages="method.displayErrors('publicKey')"
        :label="$t('Public Key')"
        outline
      />
      <v-text-field
        v-model="method.privateKey"
        :error-messages="method.displayErrors('privateKey')"
        :label="$t('Private Key')"
        outline
      />
      <v-layout align-start>
        <v-flex>
          <v-switch
            v-model="method.testMode"
            :label="$t('Test mode')"
          />
        </v-flex>
        <v-flex>
          <v-text-field
            v-model.number="method.order"
            :error-messages="method.displayErrors('order')"
            :label="$t('Order')"
            type="number"
            outline
          />
        </v-flex>
      </v-layout>
      <application-select v-model="method.application"/>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'PaymentProviderBraintree',
  components: { Translatable, TranslationsTabs, ImageUpload, ApplicationSelect, LoadingState },
  props: {
    method: {
      type: Object,
      default: () => {
      }
    }
  },

  data () {
    return {
      schema: {
        'code': '',
        'name': '',
        'enabled': true,
        'application': null,
        'testMode': true,
        'merchantId': '',
        'tokenizationKey': '',
        'publicKey': '******',
        'privateKey': '******',
        'description': '',
        'image': '',
        'order': null
      },
      sensitiveErrorFields: {
        merchantId: 'merchant id',
        publicKey: 'public key',
        privateKey: 'private key'
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema,
      sensitiveErrorFields: this.sensitiveErrorFields
    })
  }
}
</script>
